import React, { useEffect, useState } from "react";
import { Form, Input, Button, Spin, message, Card } from "antd";
import api from "../../api";
import { Typography } from "antd";

const { TextArea } = Input;
const { Text, Title } = Typography;

const SeoSettings = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);


  useEffect(() => {
    fetchSeoSettings();
  }, []);

  const fetchSeoSettings = async () => {
    setLoading(true);
    try {
      const response = await api.get("/panel/setting/seo", {
        params: { per_page: 10, page: 1 },
      });
      form.setFieldsValue(response.data.data);
    } catch (error) {
      message.error("خطا در دریافت تنظیمات سئو");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setButtonLoading(true);
    try {
      await api.post("/panel/setting/storeSeo", values);
      message.success("تنظیمات سئو با موفقیت ذخیره شد");
    } catch (error) {
      message.error("خطا در ذخیره تنظیمات سئو");
    } finally {
      setButtonLoading(false); 
    }
  };

  return (
    <Card>
      <h1 className="text-xl mb-4">تنظیمات سئو</h1>
      <div className="bg-gray-50 p-3 rounded-md border mb-4">
        <Text strong>راهنما:</Text>
        <p className="mt-2 text-sm text-gray-700">
          [title] => عنوان | [sep] => - | [sitename] => نام سایت | [date] =>
          تاریخ روز
        </p>
      </div>
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          //   className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <Form.Item label="توضیحات سئو" name="descriptionSeo">
            <TextArea rows={4} placeholder="توضیحات سئو را وارد کنید" />
          </Form.Item>

          <Form.Item label="کلمات کلیدی سایت با ( , ) جدا کنید" name="keywords">
            <Input placeholder="کلمات کلیدی را وارد کنید" />
          </Form.Item>

          <Form.Item label="عنوان سئو" name="titleSeo">
            <Input placeholder="عنوان سئو را وارد کنید" />
          </Form.Item>

          <Form.Item label="عنوان متای محصولات" name="post_meta_title">
            <Input placeholder="عنوان متای پست را وارد کنید" />
          </Form.Item>

          <Form.Item label="توضیحات متای محصولات" name="post_meta_description">
            <TextArea rows={4} placeholder="توضیحات متای پست را وارد کنید" />
          </Form.Item>

          <Form.Item label="عنوان متای دسته‌بندی" name="category_meta_title">
            <Input placeholder="عنوان متای دسته‌بندی را وارد کنید" />
          </Form.Item>

          <Form.Item
            label="توضیحات متای دسته‌بندی"
            name="category_meta_description"
          >
            <TextArea
              rows={4}
              placeholder="توضیحات متای دسته‌بندی را وارد کنید"
            />
          </Form.Item>

          <Form.Item label="عنوان متای برند" name="brand_meta_title">
            <Input placeholder="عنوان متای برند را وارد کنید" />
          </Form.Item>

          <Form.Item label="توضیحات متای برند" name="brand_meta_description">
            <TextArea rows={4} placeholder="توضیحات متای برند را وارد کنید" />
          </Form.Item>

          <Form.Item label="عنوان متای صفحه" name="page_meta_title">
            <Input placeholder="عنوان متای صفحه را وارد کنید" />
          </Form.Item>

          <Form.Item label="توضیحات متای صفحه" name="page_meta_description">
            <TextArea rows={4} placeholder="توضیحات متای صفحه را وارد کنید" />
          </Form.Item>

          <Form.Item label="عنوان متای خودرو" name="car_meta_title">
            <Input placeholder="عنوان متای خودرو را وارد کنید" />
          </Form.Item>

          <Form.Item label="توضیحات متای خودرو" name="car_meta_description">
            <TextArea rows={4} placeholder="توضیحات متای خودرو را وارد کنید" />
          </Form.Item>

          <Form.Item label="عنوان متای نوع خودرو" name="car_type_meta_title">
            <Input placeholder="عنوان متای نوع خودرو را وارد کنید" />
          </Form.Item>

          <Form.Item
            label="توضیحات متای نوع خودرو"
            name="car_type_meta_description"
          >
            <TextArea
              rows={4}
              placeholder="توضیحات متای نوع خودرو را وارد کنید"
            />
          </Form.Item>

          <Form.Item className="md:col-span-2 ">
            <Button type="primary" htmlType="submit" loading={buttonLoading}>
              ذخیره تنظیمات
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Card>
  );
};

export default SeoSettings;
